import { render, staticRenderFns } from "./TokenRedirect.vue?vue&type=template&id=299f71d0&"
import script from "./TokenRedirect.vue?vue&type=script&lang=js&"
export * from "./TokenRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports